(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/loading-state/assets/javascripts/loading-state-actions.js') >= 0) return;  svs.modules.push('/components/tipsen/loading-state/assets/javascripts/loading-state-actions.js');
"use strict";

const _RTK = RTK,
  createAction = _RTK.createAction;
const startLoadingAction = createAction('loadingstate/startloading');
const loadingActionContainer = createAction('loadingstate/loadstatecontainer');
const generateLoadingState = _ref => {
  let key = _ref.key,
    _ref$pause = _ref.pause,
    pause = _ref$pause === void 0 ? 0 : _ref$pause,
    payload = _ref.payload;
  return loadingActionContainer({
    key,
    pause,
    loadingPayload: payload
  });
};
setGlobal('svs.components.tipsen.loadingState.actions', {
  startLoadingAction,
  loadingActionContainer,
  generateLoadingState
});

 })(window);